import { render } from "./ProductoForm.vue?vue&type=template&id=08f42071&scoped=true"
import script from "./ProductoForm.vue?vue&type=script&lang=js"
export * from "./ProductoForm.vue?vue&type=script&lang=js"

import "./ProductoForm.vue?vue&type=style&index=0&id=08f42071&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f42071"]])

export default __exports__